import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { DirectDebitService } from "@/services/DirectDebitService"

export const getDirectDebitMandates = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const directDebitQuery = DirectDebitService.getForAccount(coreIdQuery.data)

  queries.add(coreIdQuery)
  queries.add(directDebitQuery)

  return queries.setData(directDebitQuery.data).getAggregate()
}
